"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable max-len */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.8333 0H1.16667C0.52325 0 0 0.52325 0 1.16667V12.8333C0 13.4767 0.52325 14 1.16667 14H12.8333C13.4767 14 14 13.4767 14 12.8333V1.16667C14 0.52325 13.4767 0 12.8333 0ZM5.54167 9.33333V7H8.45833V9.33333H5.54167ZM8.45833 10.5V12.8333H5.54167V10.5H8.45833ZM8.45833 3.5V5.83333H5.54167V3.5H8.45833ZM12.8333 3.5V5.83333H9.625V3.5H12.8333ZM4.375 5.83333H1.16637V3.5H4.375V5.83333ZM1.16637 7H4.375V9.33333H1.16637V7ZM9.625 7H12.8333V9.33333H9.625V7ZM1.16667 1.16667H12.8333V2.33333H1.16608V1.16667H1.16667ZM1.16667 10.5H4.375V12.8333H1.16667V10.5ZM9.625 12.8333V10.5H12.8333V12.8333H9.625Z",
  fill: "black"
}));

exports["default"] = _default;
//# sourceMappingURL=table.js.map